import { render } from "./analysis.vue?vue&type=template&id=cba8c9aa"
import script from "./analysis.vue?vue&type=script&lang=js"
export * from "./analysis.vue?vue&type=script&lang=js"

import "./analysis.vue?vue&type=style&index=0&id=cba8c9aa&lang=css"

import exportComponent from "E:\\zhaojiaming\\smz2023\\fashengren\\speaker_h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__